<app-header></app-header>
<section class="payment">
  <div class="payment-content">
    <p-toast [style]="{marginTop: '100px'}" key="custom"></p-toast>

    <ng-container *ngIf="!checkoutResponse">
      <form [formGroup]="form">
        <h1>Pagamento de Boletos</h1>

        <div class="barcode-group">
          <div class="input-group">
            <label for="barcode">Código de barras</label>
            <!-- <input [mask]="barcodeMask" type="text" id="barcode" formControlName="barcode" -->
            <input type="text" id="barcode" formControlName="barcode"
              class="ui-inputtext ui-widget" />
            <div class="form-error" ngxErrors="barcode">
              <div ngxError="required" when="dirty">
                Obrigatório.
              </div>
              <div ngxError="invalidBoleto" when="dirty">
                Boleto inválido.
              </div>
            </div>
          </div>

          <button pButton icon="pi pi-plus" label="Adicionar" (click)="addPayment()"></button>

          <p-progressSpinner *ngIf="addLoader" class="loader"></p-progressSpinner>
        </div>
      </form>

      <div class="table-responsive">
        <table *ngIf="barcodeList" class="payment-table">
          <thead>
            <tr class="too-table__row">
              <th *ngFor="let col of tableColumns" class="too-table__col">
                {{ col.header }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="barcodeList.length <= 0">
              <td colspan="5">Nenhum boleto adicionado</td>
            </tr>
            <ng-container *ngIf="barcodeList.length > 0">
              <tr *ngFor="let barcode of barcodeList; let i = index" class="too-table__row">
                <td *ngFor="let col of tableColumns" class="too-table__col">
                  <ng-container *ngIf="col.type === 'BARCODE'">
                    {{ barcode.linhaDigitavel | mask: barcodeMask }}
                  </ng-container>
                  <ng-container *ngIf="col.type === 'BANK'">
                    {{ barcode.receiver }}
                  </ng-container>
                  <ng-container *ngIf="col.type === 'DATE'">
                    {{ barcode.dueDate.date | date: 'dd/MM/yyyy' }}
                  </ng-container>
                  <ng-container *ngIf="col.type === 'AMOUNT'">
                    {{ barcode.amount.amount | currency:'BRL':'symbol':'1.2-2' }}
                  </ng-container>
                  <ng-container *ngIf="col.type === 'BUTTON'">
                    <button pButton class="ui-button-danger" icon="pi pi-trash" label="Remover"
                      (click)="onRemovePayment(i, barcode)"></button>
                  </ng-container>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>

      <p class="total">Total: {{ amountTotal | currency:'BRL':'symbol':'1.2-2' }}</p>

      <div class="button-group">
        <button pButton class="ui-button-secondary" label="Cancelar" (click)="onCancel()"></button>
        <button pButton icon="pi pi-money-bill" label="Pagar Boleto(s)" (click)="openModal()"></button>
      </div>
    </ng-container>


    <div class="voucher-notes" *ngIf="checkoutResponse">
      <h1>{{ checkoutResponse.voucherNotes[0].label }}</h1>
      <p>{{ checkoutResponse.voucherNotes[0].text }}</p>
    </div>
  </div>
</section>

<p-dialog [(visible)]="infoFormModal" [draggable]="false" [modal]="true" [responsive]="true"
  [style]="{width: '768px', minWidth: '290px'}" [baseZIndex]="10000">
  <form class="info-form" [formGroup]="infoForm">
    <h2>Insira seus dados para mandarmos a confirmação e o comprovante de quitação após o pagamento.</h2>
    <div class="input-group">
      <label for="name">Nome</label>
      <input type="text" id="name" formControlName="name" class="ui-inputtext ui-widget" />
      <div class="form-error" ngxErrors="name">
        <div ngxError="required" when="dirty">
          Obrigatório.
        </div>
      </div>
    </div>

    <div class="input-group">
      <label for="email">Email</label>
      <input type="email" id="email" formControlName="email" class="ui-inputtext ui-widget" />
      <div class="form-error" ngxErrors="email">
        <div ngxError="required" when="dirty">
          Obrigatório.
        </div>
        <div ngxError="email" when="dirty">
          E-mail inválido.
        </div>
      </div>
    </div>

    <div class="input-group">
      <label for="cpf">CPF</label>
      <input mask="000.000.000-00" type="tel" id="cpf" formControlName="cpf" class="ui-inputtext ui-widget" />
      <div class="form-error" ngxErrors="cpf">
        <div ngxError="required" when="dirty">
          Obrigatório.
        </div>
        <div ngxError="mask" when="dirty">
          CPF inválido.
        </div>
      </div>
    </div>

    <div class="input-group">
      <label for="phoneNumber">Telefone</label>
      <input mask="(00) 0000-0000 || (00) 00000-0000" type="phoneNumber" id="phoneNumber" formControlName="phoneNumber"
        class="ui-inputtext ui-widget" />
      <div class="form-error" ngxErrors="phoneNumber">
        <div ngxError="required" when="dirty">
          Obrigatório.
        </div>
        <div ngxError="mask" when="dirty">
          Telefone inválido.
        </div>
      </div>
    </div>
  </form>
  <p-footer class="modal-footer">
    <button [disabled]="infoFormLoader" type="button" pButton icon="pi pi-check" (click)="onSubmit()"
      label="Seguir com PagSeguro"></button>
    <p-progressSpinner *ngIf="infoFormLoader" class="loader"></p-progressSpinner>
  </p-footer>
</p-dialog>
